// https://www.tjvantoll.com/2015/09/13/fetch-and-errors/
export function throwOnError(response) {
    if (!response.ok) {
        throw Error(response.statusText);
    }
    return response;
}
